const VERTICAL_SPACING = 150;

function getConnectedNodes(newNode, nodes, edges) {
    const incoming = edges.find(e => e.target === newNode.id);
    const outgoing = edges.find(e => e.source === newNode.id);
  
    return {
      prevNode: nodes.find(n => n.id === incoming?.source),
      nextNode: nodes.find(n => n.id === outgoing?.target),
    };
  }
  

// function calculateMidPosition(prevNode, nextNode) {
//     if (prevNode && nextNode) {
//         console.log(prevNode, nextNode, {
//             x: prevNode.position.x,
//             y: ((prevNode.position.y + nextNode.position.y) / 2) + VERTICAL_SPACING,
//         })
//         return {
//             x: prevNode.position.x,
//             y: ((prevNode.position.y + nextNode.position.y) / 2) + VERTICAL_SPACING,
//         };
//     }
    
//     if (prevNode) {
//       return {
//         x: prevNode.position.x,
//         y: prevNode.position.y + VERTICAL_SPACING,
//       };
//     }
  
//     return { x: 0, y: 0 };
//   }
  

function shiftNodesBelow(nodes, insertedY) {
    return nodes.map(node => {
      if (node.position.y >= insertedY) {
        return {
          ...node,
          position: {
            ...node.position,
            y: Number(node.position.y) + VERTICAL_SPACING,
          },
        };
      }
      return node;
    });
  }
  

export function insertNodeWithShift(initialNodes, initialEdges) {
  
    const zeroNodes = initialNodes.filter(
      n => n.position.x === 0 && n.position.y === 0
    );
  
    if (zeroNodes.length === 0) return initialNodes;
  
    let updatedNodes = [...initialNodes];
  
    zeroNodes.forEach(newNode => {
  
      const { prevNode, nextNode } = getConnectedNodes(
        newNode,
        updatedNodes,
        initialEdges
      );
  
    //   const newPosition = calculateMidPosition(prevNode, nextNode);
  
      // STEP 1 — Shift nodes below next node
      if (nextNode) {
        updatedNodes = shiftNodesBelow(updatedNodes, nextNode.position.y);
      }
  
      // STEP 2 — Place new node
      updatedNodes = updatedNodes.map(node => {
        if (node.id === newNode.id) {
          return {
            ...node,
            position: {x: Number(prevNode?.position?.x), y: Number(prevNode?.position?.y) + VERTICAL_SPACING},
            // position: newPosition,
          };
        }
        return node;
      });
    });
  
    return updatedNodes;
  }
  